import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { JsonHttpService } from '../../shared/http/json-http.service'

@Injectable({
    providedIn: 'root'
})
export class TrackingDocumentStylesheetService {

    constructor(private httpService: JsonHttpService) { }

    getStylesheetToken(fileGuid: string, stylesheetArtifactGuid: string): Promise<string> {
        const options = {
            params: new HttpParams()
                .set('fileGuid', fileGuid)
                .set('stylesheetArtifactGuid', stylesheetArtifactGuid)
        };
        return this.httpService.get('/api/tracking/stylesheet/get-stylesheet-token', options).toPromise();
    }
}
